import { useTranslation } from 'react-i18next'

import ScenarioSection from '../ScenarioSection/ScenarioSection'
import ScenarioReturnRequestCard from './ScenarioReturnRequestCard/ScenarioReturnRequestCard'

const ReturnRequestsScenario = ({ scenarioReturnRequests }) => {
  const { t } = useTranslation()

  return (
    <ScenarioSection
      title={t('Solicitudes de devolución')}
      emptyDescription={t('Añade solicitudes de devolución al pedido para ver el bloque en el layout.')}
      addLabel={t('Añadir solicitud de devolución')}
      isEmpty={scenarioReturnRequests.entries.length === 0}
      onAdd={scenarioReturnRequests.add}
    >
      {scenarioReturnRequests.entries.map((returnRequest, index) => (
        <ScenarioReturnRequestCard
          key={returnRequest.id}
          returnRequest={returnRequest}
          position={index + 1}
          onChange={scenarioReturnRequests.update}
          onRemove={scenarioReturnRequests.remove}
        />
      ))}
    </ScenarioSection>
  )
}

export default ReturnRequestsScenario
